import React from "react";


import { store } from "../../redux/store";
import { connect } from "react-redux";
import history from "../../auth/history";
import $ from "jquery";

import UserJpg from "../../../src/assests/images/user.jpg";
import './HeaderProfile.css';
import moment from "moment";
import { resetMiscData } from './../../redux/misc-data/misc-data.action';


class HeaderProfile extends React.Component{
    constructor(props){
        super(props);
        this.state={
			phoneNo: this.props.phone,
			password:'',
			otpRef:'',
			message:''
		}
    }

	

    componentDidMount(){

     
       
	}
	componentWillUnmount(){
    }


	 





  
	goBackUrl=()=>{
	

		localStorage.clear();
		setTimeout(() =>{
		store.dispatch(resetMiscData);
		window.location.href='/login';
		
		window.location.href='https://ssotest.rajasthan.gov.in/signin';

		},500);
		

	}
    

    render(){

    return(
           
        <div class="col-12 col-lg-4 order-lg-3">
					<div class="topcard">
						<div class="profile-box">

						
								<button type="button" class="userlogo" data-toggle="tooltip" title="Go back eMitra" 
								onClick={this.goBackUrl}
							
								>



									<img src={UserJpg} alt="User"/> 
									<span class="goback">Go back</span></button>

							
							
							<p>Welcome! <span>{this.props.agentInfo.kioskName}</span></p>
							<p>User ID: <span>{this.props.agentInfo.id}</span></p>

						
							<p class="calnder">Last Login:  <span>{moment(this.props.loginTime).format("DD-MM-YYYY hh:mm:ss")}</span></p>
						</div>
					</div>
					</div>
				
				
		);
      } 
}


const mapStateToProps = ({errorMessageReduce:{errorMessage,loginErrorMessage},
	miscReduce:{phone,agentInfo,token,loginTime}}
	) => ({
		errorMessage,loginErrorMessage,phone,agentInfo,token,loginTime
});




export default connect(mapStateToProps, null)(HeaderProfile);
